import {FIELD_LIST_SECTION_ABOUT_US} from "../../utils/input-field-list-static-page";
import {useDispatch, useSelector} from "react-redux";
import {setAboutUsSection2Detail} from "../../reducers/about-us.reducer";
import React from "react";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const Section2 = () => {
    const dispatch = useDispatch()
    const {section2Detail, aboutUsErrorMessage} = useSelector(state => state.aboutUsReducer)
    let fieldList = FIELD_LIST_SECTION_ABOUT_US
    let showSection2 = {
        label: 'Section 2',
        key: 'show_section_2',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAboutUsSection2Detail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        console.log(section2Detail)
        // submit form
    }

    return (
        <FormGeneralComponent
            data={section2Detail}
            switchToggleField={showSection2}
            fieldList={fieldList}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            itemInputClassName={{
                key: 'description',
                value: ['col-span-2', '']
            }}
            errorMessage={aboutUsErrorMessage}
        />
    )
}

export default Section2